import axios from 'axios'

import { env } from '@/env'

export type AccessReconciliationResult = 'allowed' | 'no-ticket' | 'unknown'

export type CheckAccess = (
  tenantSlug: string,
  accessToken: string
) => Promise<boolean | null>

export async function checkUserAccess(
  tenantSlug?: string | null,
  accessToken?: string | null
): Promise<boolean | null> {
  if (!tenantSlug || !accessToken) return null

  try {
    const res = await axios.get(
      `${env.NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL}/user/digital_products/${tenantSlug}/user_access`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    return res.data?.record === true
  } catch {
    return null
  }
}

export async function reconcileEventAccess({
  tenantSlug,
  accessToken,
  checkAccess = checkUserAccess
}: {
  tenantSlug?: string | null
  accessToken?: string | null
  checkAccess?: CheckAccess
}): Promise<AccessReconciliationResult> {
  if (!tenantSlug || !accessToken) return 'unknown'

  const hasTicket = await checkAccess(tenantSlug, accessToken)

  if (hasTicket === true) return 'allowed'
  if (hasTicket === false) return 'no-ticket'

  return 'unknown'
}
